import { render } from "./WhatsappIntegration.vue?vue&type=template&id=2fc53244"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/WhatsappIntegration.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2fc53244"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2fc53244', __exports__)) {
    api.reload('2fc53244', __exports__)
  }
  
  module.hot.accept("./WhatsappIntegration.vue?vue&type=template&id=2fc53244", () => {
    api.rerender('2fc53244', render)
  })

}


export default __exports__